import React from 'react';

import { useOutstandingResponsesReport, useOutstandingResponsesReportCsv } from 'api';
import { useOutstandingResponseFilters } from './hooks';
import { BaseReport } from '../..';

export const OutstandingResponsesReport: React.FC = () => {
  useOutstandingResponsesReport();
  const filters = useOutstandingResponseFilters();
  const { mutate: exportCsv } = useOutstandingResponsesReportCsv();

  return <BaseReport filters={filters} exportCsv={exportCsv} />;
};
